<template>
  <div class="row">
    <div v-for="(module, index) in modules" :key="index" class="col-md-6 mb-4">
      <module-card
        :service="module"
        :organization="organization"
        :refreshing-service-id="refreshingServiceIdInternal"
        @onSubmited="handleServiceSubmited"
        @onClosed="handleViewClosed"
        @onSusbcribed="handleSusbcribed"
      />
    </div>
  </div>
</template>

<script>
import ModuleCard from "./ModuleCard.vue";

export default {
  name: "ModulesList",
  components: { ModuleCard },
  props: {
    modules: { type: Array, required: true },
    organization: { type: Object, required: true },
    refreshingServiceId: { type: [Number, String], default: null },
  },
  data() {
    return {
      refreshingServiceIdInternal: this.refreshingServiceId,
    };
  },
  methods: {
    handleServiceSubmited({ success, service }) {
      this.$emit("onSubmited", { success, service });
    },
    handleViewClosed() {
      this.$emit("onClosed");
    },
    handleSusbcribed() {
      this.$emit("onSusbcribed");
    },
  },
  watch: {
    refreshingServiceId(newValue) {
      this.refreshingServiceIdInternal = newValue;
      console.log("ModulesList - refreshingServiceId changed:", newValue);
    },
  }
};
</script>
